/*!
 * filename-regex <https://github.com/regexps/filename-regex>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert
 * Licensed under the MIT license.
 */

module.exports = function filenameRegex() {
  return /([^\\\/]+)$/;
};



//////////////////
// WEBPACK FOOTER
// ./~/filename-regex/index.js
// module id = 820
// module chunks = 0